import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { problems } from '../data/content';
export function Problems() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="problems-heading" data-id="element-145" data-mp="32517ed8t05ca">
      <div className="mx-auto max-w-6xl px-5" data-id="element-146" data-mp="322ofb79c0eli">
        <div id="problems-heading" data-id="element-147" data-mp="2y48th6ozlc9o">
          <SectionHeading eyebrow="Sound familiar?" title="The everyday struggles so many moms face" data-id="element-148" data-mp="2y37amg1qblhe" />
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-149" data-mp="2o4qc8y0go4lb">
          {problems.map((problem, index) => <motion.article key={problem.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="rounded-3xl border border-blush-100 bg-cream p-6" data-id="element-150" data-mp="2j6yazddxf64g" data-mpi={index}>
              <span className="text-3xl" aria-hidden="true" data-id="element-151" data-mp="34qbtbqzpn8h0">
                {problem.emoji}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold text-ink" data-id="element-152" data-mp="39q7wxp4hwxw1">{problem.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-153" data-mp="2vqyhiro467t4">{problem.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}